import { render, staticRenderFns } from "./satisdagilimi.vue?vue&type=template&id=9724fa58&"
import script from "./satisdagilimi.vue?vue&type=script&lang=js&"
export * from "./satisdagilimi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports